@import "../../styles/colors";

.root {
  background-color: $tan;
}

:global {
  body {
    margin: 0;
    font-family: "Roboto Mono", san-serif;
    color: $tan;
    font-size: 12px;
    font-weight: 300;
  }

  h1,
  .h1 {
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 700;
    font-style: italic;
    letter-spacing: 0.3em;
    color: $plum;
  }

  code {
    display: inline-block;
    margin: 0 0.4em 0 0;
    font-family: "Roboto Mono", san-serif;
    background-color: lighten($plum, 10%);
    padding: 0.2em 0.4em;
    border-radius: 3px;
  }

  p {
    margin: 2em 0;
    font-size: 1.2em;
    line-height: 1.6;
    color: darken($tan, 15%);
  }

  * {
    box-sizing: border-box;
  }

  a {
    color: $tan;
    text-decoration: none;
    font-weight: bold;
    cursor: url(../../public/cursor-dot-hover.png), auto;
    &:hover {
      color: $purple;
      cursor: url(../../public/cursor-dot-hover.png), auto;
    }
  }

  hr {
    width: 100%;
    height: 3em;
    background-color: #fff;
    border: none;
  }

  .btn {
    display: inline-block;
    border: 2px solid #ff00ff;
    padding: 0.6em 1em;
    color: black;
    font-weight: 500;
    margin-right: 1em;
    transition: all 0.3s ease-in-out;
    cursor: url(../../public/cursor-dot-hover.png), auto;

    &:hover {
      background-color: #ff00ff;
      color: $tan;
      transition: all 0.3s ease-in-out;
      border: 2px solid black;
      cursor: url(../../public/cursor-dot-hover.png), auto;
    }
  }

  .visually-hidden {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    overflow: hidden;
  }
}
